templates = require 'views/internal/templates'
View = require 'view'

class LabelLimitsErrorView extends View
    tagName: 'span'
    className: 'error'
    renderOnce: ->
      @$el.html(templates.fill('label_limit_exceeded'))


module.exports = LabelLimitsErrorView


// WEBPACK FOOTER //
// ./app/scripts/views/label/label-limits-error-view.coffee